import ResultsScoreContainer from '@/components/svgs/ResultsScoreContainer'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { isNil } from 'ramda'
import { useEffect } from 'react'
import { View } from 'react-native'
import Animated, {
	Easing,
	useAnimatedStyle,
	useSharedValue,
	withRepeat,
	withTiming,
} from 'react-native-reanimated'

const ROTATION_TIME = 5000

const AnimatedResultsScoreContainer = () => {
	const rotation = useSharedValue(0)
	useEffect(() => {
		rotation.value = withRepeat(
			withTiming(360, { duration: ROTATION_TIME, easing: Easing.linear }),
			-2,
			false
		)
	}, [rotation])

	const animatedStyles = useAnimatedStyle(() => {
		return {
			transform: [
				{
					rotate: `${rotation.value}deg`,
				},
			],
		}
	})

	return (
		<Animated.View style={animatedStyles}>
			{/* 14rem */}
			<ResultsScoreContainer height={224} width={224} />
		</Animated.View>
	)
}

const WallyHealthScore = ({ score }: { score?: number }) => {
	if (isNil(score)) {
		return null
	}

	return (
		<VStack className="relative">
			<AnimatedResultsScoreContainer />
			<View className="absolute left-0 top-0 right-0 bottom-0 items-center justify-center">
				<Text className="font-apercu-bold text-5xl">{score}</Text>
			</View>
		</VStack>
	)
}

export { WallyHealthScore }
